import React from "react";
import { Accordion } from "devextreme-react";
import AdministracionItem from "./administracionItem";
import { setNombreEtapa, nombrePlanMovilidad } from "../Planes/functions";

class AccordionAdministracion extends React.PureComponent {
  render() {
    return (
      <div>
        {/* Plan actual */}
        <div className="PM-administracion">
          <span className="PM-section-title">Plan en construcción</span>
          <Accordion
            dataSource={this.props.actual}
            defaultSelectedIndex={this.props.actual[0]}
            collapsible
            itemTitleComponent={(data) => (
              <div className="row" style={{ margin: 0, marginTop: 5 }}>
                <div className="col-sm-7 PM-informativo text-left">
                  <span className="PM-label-size">Nombre</span>
                  <p>{nombrePlanMovilidad(data.fechaCreacion,data.idcentro)}</p>
                </div>
                  <div className="col-sm-3 PM-informativo text-left">
                    <span className="PM-label-size">Estado Plan</span>
                    <p>{setNombreEtapa(data.estadoProceso-1)}</p>
                  </div>
                  <div className="col-sm-2">
                    <div className="PM-plan-ejecucion">
                      Borrador
                    </div>
                  </div>
              </div>
            )}
            itemComponent={(data) => <AdministracionItem data={data} />}
          />
        </div>
        {/* Planes anteriores */}
        <div className="PM-administracion">
          <span className="PM-section-title">Planes finalizados</span>
          <Accordion
            dataSource={this.props.planes}
            defaultSelectedIndex={null}
            collapsible = {false}
            itemTitleComponent={(data) => (
              <div className="row" style={{ margin: 0, marginTop: 5 }}>
                <div className="col-sm-7 PM-informativo text-left">
                  <span className="PM-label-size">Nombre</span>
                  <p>{nombrePlanMovilidad(data.fechaCreacion,data.idcentro)}</p>
                </div>
                <div className="col-sm-3 PM-informativo text-left">
                  <span className="PM-label-size">Encargado</span>
                  <p>{data.rutusuarioNavigation.nombre}</p>
                </div>
                <div className="col-sm-2">
                  <div className="PM-plan-finalizada">
                    Finalizado
                  </div>
                </div>
              </div>
            )}
            // itemComponent={(data) => <AdministracionItem data={data} />}
          />
        </div>
      </div>
    );
  }
}

export default AccordionAdministracion;
